(function () {
  var instances = [];
  var ticking = false;
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function smoothstep(t) {
    return t * t * (3 - 2 * t);
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function findVisibleWithin(root, selector) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i += 1) {
      if (isVisible(nodes[i])) return nodes[i];
    }
    return nodes[0] || null;
  }

  function getInstance(root) {
    for (var i = 0; i < instances.length; i += 1) {
      if (instances[i].root === root) return instances[i];
    }
    return null;
  }

  function createMergedStageInstance(root) {
    return {
      root: root,
      type: 'merged-stage',
      pairs: [],
      rootFlows: [],
    };
  }

  function createCharSpan(char, index) {
    if (char === ' ') {
      var space = document.createElement('span');
      space.className = 'cd-wq-space';
      space.textContent = '\u00A0';
      return space;
    }

    var span = document.createElement('span');
    span.className = 'cd-wq-letter';
    span.textContent = char;
    span.setAttribute('data-cd-wq-char-index', String(index));
    return span;
  }

  function appendSplitText(text, fragment, counter) {
    var parts = text.split(/(\s+)/);

    parts.forEach(function (part) {
      if (!part) return;

      if (/^\s+$/.test(part)) {
        for (var i = 0; i < part.length; i += 1) {
          fragment.appendChild(createCharSpan(' ', counter.value));
          counter.value += 1;
        }
        return;
      }

      var word = document.createElement('span');
      word.className = 'cd-wq-word';

      for (var j = 0; j < part.length; j += 1) {
        word.appendChild(createCharSpan(part.charAt(j), counter.value));
        counter.value += 1;
      }

      fragment.appendChild(word);
    });
  }

  function splitNodeTree(sourceNode, targetNode, counter) {
    Array.prototype.slice.call(sourceNode.childNodes).forEach(function (child) {
      if (child.nodeType === Node.TEXT_NODE) {
        appendSplitText(child.textContent || '', targetNode, counter);
        return;
      }

      if (child.nodeType !== Node.ELEMENT_NODE) return;

      if (child.tagName === 'BR') {
        targetNode.appendChild(document.createElement('br'));
        return;
      }

      var clone = document.createElement(child.tagName.toLowerCase());
      Array.prototype.slice.call(child.attributes).forEach(function (attribute) {
        clone.setAttribute(attribute.name, attribute.value);
      });
      splitNodeTree(child, clone, counter);
      targetNode.appendChild(clone);
    });
  }

  function prepareLetterFlow(el) {
    if (!el || el.hasAttribute('data-cd-wq-letterflow-ready')) return el;

    var counter = { value: 0 };
    var fragment = document.createDocumentFragment();
    var originalText = (el.textContent || '').replace(/\s+/g, ' ').trim();

    splitNodeTree(el, fragment, counter);

    el.innerHTML = '';
    el.appendChild(fragment);
    el.classList.add('cd-wq-letterflow-ready');
    el.setAttribute('data-cd-wq-letterflow-ready', 'true');
    el.setAttribute('data-cd-wq-char-total', String(counter.value));

    if (originalText) {
      el.setAttribute('aria-label', originalText);
    }

    return el;
  }

  function getLetterFlows(scope) {
    if (!scope) return [];
    return Array.prototype.slice
      .call(scope.querySelectorAll('[data-cd-wq-letterflow]'))
      .map(prepareLetterFlow)
      .filter(Boolean);
  }

  function getRevealBlocks(scope) {
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('[data-cd-wq-reveal]'));
  }

  function rebuildMergedStage(instance) {
    if (!instance || !instance.root) return;

    instance.rootFlows = getLetterFlows(instance.root.querySelector('.cd-home-merged__headline'));

    instance.pairs = ['hero', 'product']
      .map(function (key) {
        var copy = instance.root.querySelector('[data-cd-merged-copy="' + key + '"]');
        if (!copy) return null;

        return {
          key: key,
          copy: copy,
          mediaSelector: '[data-cd-merged-media="' + key + '"]',
          flows: getLetterFlows(copy),
          reveals: getRevealBlocks(copy),
        };
      })
      .filter(Boolean);
  }

  function registerMergedStage(root) {
    if (!root) return null;

    var instance = getInstance(root);
    if (!instance) {
      instance = createMergedStageInstance(root);
      instances.push(instance);
    }

    rebuildMergedStage(instance);
    return instance;
  }

  function resetRevealBlock(el) {
    if (!el) return;
    el.style.setProperty('--cd-wq-reveal-opacity', '1');
    el.style.setProperty('--cd-wq-reveal-y', '0px');
  }

  function applyRevealBlocks(items, progress) {
    items.forEach(function (item) {
      var offset = parseFloat(item.getAttribute('data-cd-wq-reveal-offset') || '0') || 0;
      var local = smoothstep(clamp((progress - offset) / 0.22, 0, 1));
      var y = (1 - local) * 18;

      item.style.setProperty('--cd-wq-reveal-opacity', local.toFixed(3));
      item.style.setProperty('--cd-wq-reveal-y', y.toFixed(2) + 'px');
    });
  }

  function resetLetterFlow(el) {
    if (!el) return;

    Array.prototype.slice.call(el.querySelectorAll('.cd-wq-letter')).forEach(function (letter) {
      letter.style.setProperty('--cd-wq-letter-opacity', '1');
      letter.style.setProperty('--cd-wq-letter-y', '0em');
    });
  }

  function applyLetterFlow(el, progress) {
    if (!el) return;

    var letters = el.querySelectorAll('.cd-wq-letter');
    var total = letters.length || 1;
    var offset = parseFloat(el.getAttribute('data-cd-wq-flow-offset') || '0') || 0;
    var staggerSpan = total > 1 ? Math.min(0.42, total * 0.012) : 0;
    var startStep = total > 1 ? staggerSpan / (total - 1) : 0;

    Array.prototype.slice.call(letters).forEach(function (letter, index) {
      var start = offset + startStep * index;
      var local = smoothstep(clamp((progress - start) / 0.18, 0, 1));
      var y = (1 - local) * 0.42;

      letter.style.setProperty('--cd-wq-letter-opacity', local.toFixed(3));
      letter.style.setProperty('--cd-wq-letter-y', y.toFixed(3) + 'em');
    });
  }

  function resetMergedStagePair(pair) {
    if (!pair) return;

    if (pair.copy) {
      pair.copy.style.setProperty('--cd-wq-opacity', '1');
      pair.copy.style.setProperty('--cd-copy-opacity', '1');
      pair.copy.style.pointerEvents = '';
    }

    (pair.reveals || []).forEach(resetRevealBlock);
    (pair.flows || []).forEach(resetLetterFlow);

    var media = pair.media;
    if (media) {
      media.style.setProperty('--cd-wq-media-y', '0px');
    }
  }

  function computeVisibility(rect, viewportHeight) {
    var entryTrigger = viewportHeight * 1.04;
    var exitTrigger = viewportHeight * 0.12;
    var enterBand = Math.max(viewportHeight * 0.34, 240);
    var exitBand = Math.max(viewportHeight * 0.28, 200);
    var enterProgress = clamp((entryTrigger - rect.top) / enterBand, 0, 1);
    var exitProgress = clamp((rect.bottom - exitTrigger) / exitBand, 0, 1);
    return smoothstep(Math.min(enterProgress, exitProgress));
  }

  function computeTravel(rect, viewportHeight) {
    return clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
  }

  function getMediaShift(rect, viewportHeight) {
    var travel = computeTravel(rect, viewportHeight);
    var isDesktop = window.innerWidth > 1024;
    var amplitude = isDesktop ? 34 : 18;
    return (0.5 - travel) * amplitude;
  }

  function getPairFlowProgress(pair, rawVisibility, travel) {
    if (pair.key === 'product') {
      var openGate = smoothstep(clamp((travel - 0.22) / 0.20, 0, 1));
      return smoothstep(rawVisibility) * openGate;
    }

    var heroGate = smoothstep(clamp((travel - 0.01) / 0.18, 0, 1));
    return smoothstep(rawVisibility) * heroGate;
  }

  function updateRootFlows(instance) {
    if (!instance.rootFlows || !instance.rootFlows.length) return;

    var headline = instance.root.querySelector('.cd-home-merged__headline');
    if (!headline) return;

    var viewportHeight = window.innerHeight || 0;
    var rect = headline.getBoundingClientRect();
    var progress = smoothstep(
      clamp((viewportHeight * 1.02 - rect.top) / Math.max(viewportHeight * 0.56, 320), 0, 1)
    );

    instance.rootFlows.forEach(function (flow) {
      applyLetterFlow(flow, progress);
    });
  }

  function updateMergedStage(instance) {
    if (!instance || !instance.root) return;

    if (prefersReducedMotion && prefersReducedMotion.matches) {
      instance.rootFlows.forEach(resetLetterFlow);
      instance.pairs.forEach(resetMergedStagePair);
      return;
    }

    var viewportHeight = window.innerHeight || 0;

    updateRootFlows(instance);

    instance.pairs.forEach(function (pair) {
      var media = findVisibleWithin(instance.root, pair.mediaSelector);
      pair.media = media;

      if (!media) {
        resetMergedStagePair(pair);
        return;
      }

      var rect = media.getBoundingClientRect();
      var rawVisibility = computeVisibility(rect, viewportHeight);
      var travel = computeTravel(rect, viewportHeight);
      var flowProgress = getPairFlowProgress(pair, rawVisibility, travel);
      var mediaShift = getMediaShift(rect, viewportHeight) * rawVisibility;

      if (pair.copy) {
        pair.copy.style.setProperty('--cd-wq-opacity', flowProgress.toFixed(3));
        pair.copy.style.setProperty('--cd-copy-opacity', flowProgress.toFixed(3));
        pair.copy.style.pointerEvents = flowProgress < 0.08 ? 'none' : '';
      }

      applyRevealBlocks(pair.reveals || [], flowProgress);
      (pair.flows || []).forEach(function (flow) {
        applyLetterFlow(flow, flowProgress);
      });

      media.style.setProperty('--cd-wq-media-y', mediaShift.toFixed(2) + 'px');
    });
  }

  function updateInstance(instance) {
    if (!instance || !instance.root) return;
    if (instance.type === 'merged-stage') {
      updateMergedStage(instance);
    }
  }

  function updateAll() {
    instances.forEach(updateInstance);
    ticking = false;
  }

  function queueUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function initRoot(root) {
    if (!root) return null;
    var type = root.getAttribute('data-cd-woodarq');
    if (type === 'merged-stage') {
      return registerMergedStage(root);
    }
    return null;
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll('[data-cd-woodarq]');
    roots.forEach(initRoot);
    queueUpdate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate);
  window.addEventListener('orientationchange', queueUpdate);
  window.addEventListener('load', queueUpdate);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:reorder', queueUpdate);

  if (prefersReducedMotion && typeof prefersReducedMotion.addEventListener === 'function') {
    prefersReducedMotion.addEventListener('change', queueUpdate);
  }

  window.CDWoodarqMotion = {
    initAll: initAll,
    refresh: function (root) {
      if (!root) {
        queueUpdate();
        return;
      }

      var section =
        root.matches && root.matches('[data-cd-woodarq]')
          ? root
          : root.querySelector && root.querySelector('[data-cd-woodarq]');

      if (!section) {
        queueUpdate();
        return;
      }

      var instance = initRoot(section);
      if (instance && instance.type === 'merged-stage') {
        rebuildMergedStage(instance);
      }
      queueUpdate();
    },
  };
})();
